module.exports = __webpack_public_path__ + "img/c7139eacaef435bf7aba6802571203dd.png";